<template>
    <section class="layout-login">
        <div class="content">
            <div class="d-flex-item">
                <p class="line-h-0">
                    <img src="static/login.png">
                </p>
            </div>
            <div class="d-flex-item">
                <div class="d-flex justify-center height-all">
                    <div class="d-block width-all" style="padding: 48px;">
                        <h6 class="align-center">
                            <img class="height-60" src="static/logo.png">
                        </h6>
                        <h2 class="ptb-sm">忘记/重置密码</h2>
                        <div class="d-block mb-sm">
                            <Input prefix="md-contact" size="large" type="text" placeholder="会员号/用户名/手机号"/>
                        </div>
                        <div class="d-flex justify-start mb-sm">
                            <div class="d-flex-item">
                                <Input prefix="md-barcode" size="large" type="text" placeholder="手机验证码"/>
                            </div>
                            <span class="d-block pl-xs">
                                <Button class="width-80" size="large" type="default">获取</Button>
                            </span>
                        </div>
                        <div class="d-block mb-sm">
                            <Input prefix="md-lock" size="large" type="password" placeholder="新密码"/>
                        </div>
                        <div class="d-block mb-sm">
                            <Input prefix="md-lock" size="large" type="password" placeholder="确认密码"/>
                        </div>
                        <p class="d-block mb-sm">
                            <router-link to="login">返回登录</router-link>
                        </p>
                        <div class="d-block">
                            <Button long type="primary" shape="circle" size="large">提交</Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <p class="footer">Copyright © 2021 3rdata.com All Rights Ressrved 版权所有.第三脑域（北京）科技有限公司 本站法律顾问：陈明律师</p>
    </section>
</template>

<script type="text/javascript">
    export default {
        data() {
            return {
                loginData: {
                    userName: 'admin',
                    password: '000000'
                }
            }
        },
        mounted() {
        },
        methods: {
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/reset.vue